import { EventBus } from "shared/emmiter";
import { BarStorage, GameHeaderStorage, ScoreStorage } from "shared/storages";
import gsap from "gsap";
import { TextHelper } from "shared/helpers";
import { OriginSize } from "shared/origin";
import { UserScoreService, PopupsService } from "shared/services";
import { Game } from "screens";
import { FontsConfig } from "shared/config";
import { LevelObject } from "shared/levels";

export class FillBarService {
    private static isEnd: boolean = false;
    private static persent = {
        num: 0,
    };
    private static currentScore = {
        numForBar: 0,
        score: 0,
    };
    private static tweens = {
        numForBar: null,
        score: null,
    }
    private static currentLevel: number = 0;
    public static isGameEnd: boolean = false;

    public static resetData(): void {
        this.currentScore = {
            numForBar: 0,
            score: 0,
        };
        this.persent = {
            num: 0,
        };
        this.isEnd = false;
        GameHeaderStorage.persent.text = `${Math.floor(this.persent.num)}%`;

        if (BarStorage.barPersend) {
            BarStorage.barPersend.text = `${Math.floor(this.persent.num)}%`;
        }

        if (BarStorage.flare) {
            BarStorage.flare.x = BarStorage.flareX;
        }

        if (BarStorage.barMask) {
            BarStorage.barMask.x = BarStorage.maskOriginX;
        }

        GameHeaderStorage.maskY = 160;

        this.fillScoreMaskHeader(0);
        this.fillHeaderScore(0, 0, true);
        ScoreStorage.reset();
    }

    public static changeScore(score: number, open: number, target: number, level: number, timer: number): void {

        if (this.isGameEnd) {
            return;
        }

        this.currentLevel = level;
        const persent = open / target * 100;
        const currentScore = Math.floor(this.currentScore.score + score);

        gsap.to(this.persent, {
            num: persent, duration: 1, ease: 'none', onUpdate: () => {
                GameHeaderStorage.persent.text = `${Math.floor(this.persent.num)}%`;
            }
        })

        this.fillScoreMaskHeader(persent);
        this.fillHeaderScore(score, timer);

        if (persent >= 100) {
            this.isGameEnd = true;
            EventBus.emit('game_end');
            UserScoreService.changeScore(currentScore);
            
            setTimeout(() => {
                PopupsService.openWinPopup(this.currentLevel, currentScore);
            }, timer)
        }
    }

    public static changeBarFill(score: number, progress: number, level: number): void {
        if (this.isGameEnd) {
            return;
        }
        this.currentLevel = level;
        this.persent.num = this.persent.num + progress;
        let animTarget = BarStorage.maxScore * this.persent.num / 100;

        if (animTarget >= BarStorage.maxScore) {
            animTarget = BarStorage.maxScore;
        }

        this.tweens.numForBar = gsap.to(this.currentScore, {
            numForBar: animTarget, duration: 1, ease: 'none',
            onStart: () => {
                gsap.to(BarStorage.flare, { alpha: 1, duration: 0.3, ease: 'none' });
                gsap.to(BarStorage.flare, {
                    x: animTarget, duration: 1, ease: 'none', onUpdate: () => {
                        const persentBar = BarStorage.flare.x / BarStorage.maxScore * 100;
                        const persentScore = 85 * persentBar / 100;
                        BarStorage.barPersend.text = `${Math.floor(persentBar)}%`;
                        GameHeaderStorage.persent.text = `${Math.floor(persentBar)}%`;

                        if (Math.floor(persentBar) >= 100 && !this.isGameEnd) {
                            this.isGameEnd = true;
                            EventBus.emit('game_end');
                            this.tweens.numForBar.kill();
                            this.tweens.score.kill();
                            UserScoreService.changeScore(Math.floor(this.currentScore.score));
                            PopupsService.openWinPopup(this.currentLevel, Math.floor(this.currentScore.score));
                            // this.popup();
                        } else {
                            BarStorage.barMask.x = BarStorage.maskOriginX + this.currentScore.numForBar;
                            // BarStorage.barMask.beginFill();
                            // BarStorage.barMask.drawRect(30, 455, this.currentScore.numForBar, BarStorage.barMask.height - 15);
                            // BarStorage.barMask.endFill();

                            this.fillScoreMaskHeader(persentScore * 1.05);

                        }
                    }, onComplete: () => {
                        gsap.to(BarStorage.flare, { alpha: 0, duration: 0.3, ease: 'none' });
                    }
                })
            },
        })

        this.fillHeaderScore(score, 0, true);
    }

    private static fillScoreMaskHeader(persentScore): void {
        if (this.isGameEnd) {
            return;
        }

        persentScore = Math.floor(persentScore);
        GameHeaderStorage.mask.y = GameHeaderStorage.maskY - persentScore;

        if (persentScore === 0) {
            GameHeaderStorage.mask.y = GameHeaderStorage.mask.height;
        }
    }


    private static fillHeaderScore(score, timer = 0, isFillBar = false): void {

        let scoreTarget = Math.floor(this.currentScore.score + score);
        ScoreStorage.setScore(scoreTarget);
        this.tweens.score = gsap.to(this.currentScore, {
            score: scoreTarget, duration: 1, ease: 'none', onUpdate: () => {
                if (this.currentScore.score <= 1000) {
                    GameHeaderStorage.score.text = Math.floor(this.currentScore.score) + '';
                    GameHeaderStorage.scoreMask.text = Math.floor(this.currentScore.score) + '';
                } else {
                    GameHeaderStorage.score.text = TextHelper.numberWithCommas(Math.floor(this.currentScore.score));
                    GameHeaderStorage.scoreMask.text = TextHelper.numberWithCommas(Math.floor(this.currentScore.score));
                }

                if (this.currentScore.score < 10) {
                    GameHeaderStorage.score.x = OriginSize.width - 200;
                    GameHeaderStorage.scoreMask.x = OriginSize.width - 200;
                }

                if (this.currentScore.score >= 10) {
                    GameHeaderStorage.score.x = OriginSize.width - 270;
                    GameHeaderStorage.scoreMask.x = OriginSize.width - 270;
                }

                if (this.currentScore.score >= 100) {
                    GameHeaderStorage.score.x = OriginSize.width - 330;
                    GameHeaderStorage.scoreMask.x = OriginSize.width - 330;
                }

                if (this.currentScore.score >= 1000) {
                    GameHeaderStorage.score.x = OriginSize.width - 430;
                    GameHeaderStorage.scoreMask.x = OriginSize.width - 430;
                }

                if (this.currentScore.score >= 10000) {
                    GameHeaderStorage.score.x = OriginSize.width - 500;
                    GameHeaderStorage.scoreMask.x = OriginSize.width - 500;
                }

                if (this.currentScore.score >= 100000) {
                    GameHeaderStorage.score.x = OriginSize.width - 600;
                    GameHeaderStorage.scoreMask.x = OriginSize.width - 600;
                }

                if (this.currentScore.score >= 1000000) {
                    GameHeaderStorage.score.x = OriginSize.width - 700;
                    GameHeaderStorage.scoreMask.x = OriginSize.width - 700;
                }
            }
        })
    }

    public static losePopup(): void {
        const lose_black_bg = document.getElementById('lose_black_bg');
        const try_again = document.getElementById('try_again');
        const popup = document.getElementById('lose_popup');
        popup.style.display = 'flex';

        lose_black_bg.addEventListener('click', (e: any) => {
            if (e.target.className === 'black_bg') {
                EventBus.emit('reset_game');
                popup.style.display = 'none';
                this.currentScore.numForBar = 0;
                this.isEnd = false;
                this.resetHeader();
            }
        })

        try_again.addEventListener('click', (e: any) => {
            if (e.target.className === 'collect_btn') {
                EventBus.emit('reset_game');
                popup.style.display = 'none';
                this.currentScore.numForBar = 0;
                this.isEnd = false;
                this.resetHeader();
            }
        })
    }

    public static popup(): void {
        this.currentScore.numForBar = 0;
        const win_black_bg = document.getElementById('win_black_bg');
        const collect_btn = document.getElementById('collect_btn');
        const popup = document.getElementById('win_popup');
        popup.style.display = 'flex';

        win_black_bg.addEventListener('click', (e: any) => {
            if (e.target.className === 'black_bg') {
                EventBus.emit('reset_game');
                popup.style.display = 'none';
                this.currentScore.numForBar = 0;
                this.isEnd = false;
                this.resetBar();
                this.resetHeader();
            }
        })

        collect_btn.addEventListener('click', (e: any) => {
            if (e.target.className === 'collect_btn') {
                EventBus.emit('reset_game');
                popup.style.display = 'none';
                this.currentScore.numForBar = 0;
                this.isEnd = false;
                this.resetBar();
                this.resetHeader();
            }
        })
    }

    private static resetBar(): void {

        if (BarStorage.barMask) {
            BarStorage.barMain.removeChild(BarStorage.barMask);

            const newMask = new PIXI.Graphics();
            newMask.beginFill();
            newMask.drawRect(BarStorage.barMask.x, BarStorage.barMask.y, 0, BarStorage.barMask.height);
            newMask.endFill();
            BarStorage.barMain.mask = newMask;
            BarStorage.barMask = newMask;
            BarStorage.flare.x = 0;
            BarStorage.flare.alpha = 0;
            BarStorage.barPersend.text = `0%`;
            this.persent.num = 0;
            this.currentScore.score = 0;
        }
    }

    private static resetHeader(): void {
        GameHeaderStorage.score.x = OriginSize.width - 250;
        GameHeaderStorage.scoreMask.x = OriginSize.width - 250;
        GameHeaderStorage.score.text = TextHelper.numberWithCommas('0');
        GameHeaderStorage.scoreMask.text = TextHelper.numberWithCommas('0');

        GameHeaderStorage.persent.text = `0%`;

        GameHeaderStorage.container.removeChild(GameHeaderStorage.mask);

        const newMask = new PIXI.Graphics()

        newMask.beginFill(0xFC2561);
        newMask.drawRect(GameHeaderStorage.mask.x, GameHeaderStorage.maskY, GameHeaderStorage.mask.width, GameHeaderStorage.mask.height);
        newMask.endFill();
        GameHeaderStorage.container.addChild(newMask);
        GameHeaderStorage.mask = newMask;
        newMask.mask = GameHeaderStorage.scoreMask;
    }

    public static reset(): void {
        EventBus.emmiter.on('reset_game', () => {
            this.currentScore.numForBar = 0;
        })
    }
}